import { ObjectType, LinkAuthException, LinkAuthError } from 'phoenix/domain';
import { AuthService } from 'phoenix/services';
import { CommonUtilsService } from 'util/util';
require('./myFiles.styles');

interface StateRedirect {
	to:string;
	params:any;
}

export const myFilesModule = angular
	.module('sharebase-app.myFiles', [
		'ui.router', 
		'util.common',
		'sharebase', 
		'phoenix.services'
	])
	.config([
		'$stateProvider',
		'$urlRouterProvider',
		function ($stateProvider, $urlRouterProvider, PX_OBJECT_TYPE) {
			$stateProvider
				.state('content.myFiles.home', {
					url: '',
					data: {
						isTopLevel: true
					},
					resolve: {
						promiseObj: [
							'$stateParams',
							'sbaViewItemIndexDataStore',
							function ($stateParams, sbaViewItemIndexDataStore) {
								var path = '/';
								//get index
								$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
								//clear index
								sbaViewItemIndexDataStore.remove(path);									
								return;
							}
						]
					},
					views: {
						'myFilesContent': {
							template: function (params) { return '<sba-folder-view flex item-index="' + params.itemIndex + '"></sba-folder-view>';}
						},
						'homeDetails@content': {template: '<sba-empty-details flex />'}
					},
					onExit: [
						'$location',
						'sbaViewItemIndexDataStore',
						function ($location, sbaViewItemIndexDataStore) {
							var index = angular.element(document.querySelector('sba-folder-view')).attr('item-index');
							sbaViewItemIndexDataStore.add($location.path(), index);
						}
					]
				})
				.state('content.myFiles.folder', {
					url: 'folder/:folderID',
					resolve: {
						promiseObj: [
							'$q',
							'$state',
							'$stateParams',
							'$location',
							'sbaLibraryDataStore',
							'sbaFolderDataStore',
							'sbaViewItemIndexDataStore',
							function ($q, $state, $stateParams, $location, sbaLibraryDataStore, sbaFolderDataStore, sbaViewItemIndexDataStore) {								
								//get index
								var path = '/folder/' + $stateParams.folderID;
								$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
								//clear index
								sbaViewItemIndexDataStore.remove(path);										
							}]
					},
					views: {
						'myFilesContent': {
							template: function (params) {
								return '<sba-folder-view flex folder-id="' + params.folderID + '" item-index="' + params.itemIndex + '"></sba-folder-view>';
							}
						},
						'homeDetails@content':{
							template: function (params) {return '<sba-folder-details folder-id="' + params.folderID + '"></sba-folder-details>';}
						}
					},
					onExit: [
						'$location',
						'sbaViewItemIndexDataStore',
						'sbaFolderDataStore',
						'sbaDocumentNavigationService',
						function ($location, sbaViewItemIndexDataStore, sbaFolderDataStore, sbaDocumentNavigationService) {
							sbaDocumentNavigationService.setFolder(sbaFolderDataStore); 
							sbaFolderDataStore.clearStore();
							var index = angular.element(document.querySelector('sba-folder-view')).attr('item-index');
							sbaViewItemIndexDataStore.add($location.path(), index);
						}]
				})
				.state('content.myFiles.folder.share', {
					url :'/share/:token?recipient',
					params: {
						password: null
					},
					data: {
						rule: guardShareRoute(ObjectType.FOLDER),
						// this route can be accessed with a share-by-link token
						allowUnauthenticatedAccess: true,
						shareView: true
					},
					onExit: [
						'pxAuthService',
						'$state',
						function(pxAuthService, $state){
							var currentState = $state.current.name;
							var isShare = currentState.indexOf('folder.share') >= 0 || currentState.indexOf('document.share') >= 0;
							if (!isShare) {
								pxAuthService.invalidateLogin(true);
							}
						}
					]
				})
				.state('content.myFiles.document', {
					url: 'document/:docID',
					views: {
						'myFilesContent': { template: function (params) { return '<sba-document-view flex document-id="' + params.docID + '"></sba-document-view>'; } },
						'homeDetails@content': {
							template: function (params) {
								return '<sba-document-details document-id="' + params.docID + '" flex></sba-document-details>';
							}
						}
					}
				})
				.state('content.myFiles.document.share', {
					url :'/share/:token?recipient',
					params: {
						password: null
					},
					data: {
						rule: guardShareRoute(ObjectType.DOCUMENT),
						// this route can be accessed with a share-by-link token
						allowUnauthenticatedAccess: true,
						shareView: true
					},
					onExit: [
						'pxAuthService',
						'$state',
						function(pxAuthService, $state){
							var currentState = $state.current.name;
							var isShare = currentState.indexOf('folder.share') >= 0 || currentState.indexOf('document.share') >= 0;
							if (!isShare) {
								pxAuthService.invalidateLogin(true);
							}
						}
					]
				})
				.state(generateEmailReferralState('content.myFiles.document'))
				.state(generateEmailReferralState('content.myFiles.document.share'))
				.state('content.myFiles.search', {
					url: 'search-results/',
					params: {
						phrase: ''
					},
					resolve: {
						promiseObj: [
							'$stateParams',
							'sbaViewItemIndexDataStore',
							function ($stateParams, sbaViewItemIndexDataStore) {									
								//get index
								var path = '/search-results/' + $stateParams.phrase;
								//get index
								$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
								//clear index
								sbaViewItemIndexDataStore.remove(path);	
						}]
					},
					views: {
						'myFilesContent': {
							template: params => {									
								//use full text search
								
								return `<sba-content-search-results flex search-phrase="${params.phrase}" item-index="${params.itemIndex}"></sba-content-search-results>`;
							}
						},
						'homeDetails@content': { template: '<sba-empty-details flex />' }
					},
					onExit: [
						'$location',
						'sbaViewItemIndexDataStore',
						function ($location, sbaViewItemIndexDataStore) {
							var index = angular.element(document.querySelector('sba-content-search-results')).attr('item-index');
							sbaViewItemIndexDataStore.add($location.path(), index);
						}]
				});

			function guardShareRoute(itemType){
				return [
					'utils',
					'$q', 
					'$stateParams', 
					'pxAuthService', 
					'sbPinRepo',
					'gettextCatalog',
					guardShareHandler
				]; 

				function guardShareHandler (
					utils:CommonUtilsService,
					$q:ng.IQService, 
					$stateParams:ng.ui.IStateParamsService, 
					pxAuthService:AuthService, 
					sbPinRepo, 
					gettextCatalog:ng.gettext.gettextCatalog
				) {
					let p:ng.IPromise<StateRedirect|void>;
					let params = $stateParams.toState || {};
					
					//copy password link params forward
					params.token = params.token || $stateParams.token;
					params.password = params.password || $stateParams.password;
					params.recipient = params.recipient || $stateParams.recipient;
					
					if(params.password){
						params.password = utils.htmlDecode(params.password);
					}

					if(!params.password && pxAuthService.lastLinkPassword){
						params.password = pxAuthService.lastLinkPassword;
						pxAuthService.lastLinkPassword = null;
					}

					var defaultErrorMessage = gettextCatalog.getString('Invalid or expired link.');

					const getLoginRedirect = (errorMessage:string):StateRedirect => {
						return {
							to: 'login',
							params: {
								errorMessage: errorMessage
							}
						};
					} 

					const getAuthLinkRedirect = (params:string):StateRedirect => {
						return {
							to: 'sharedLinkAuth',
							params: params
						}
					};

					params.itemType = itemType;
					params.itemId = params.docID || params.folderID;

					if(!params.token){
						p = $q.resolve(getLoginRedirect(defaultErrorMessage));
					}
					else if(params.recipient && !params.password && !sbPinRepo.has(params.token)){
						p = $q.resolve(getAuthLinkRedirect(params));
					} 
					else {
						p = pxAuthService
							.establishLinkUser(itemType, params.token, params.password, params.recipient)
							.catch((e:LinkAuthException) => {
								// @TODO: Remove this fallback if when SBAPI-896 gets resolve
								// https://jira.hylandqa.net/browse/SBAPI-896
								if (e.type === LinkAuthError.LINK_NOT_FOUND && itemType === ObjectType.DOCUMENT) {
									// document share does not exist, see if it is a folder share
									return pxAuthService.establishLinkUser(ObjectType.FOLDER, params.token, params.password, params.recipient);
								}
								return $q.reject(e);
							})
						if (!params.recipient && !params.password && !sbPinRepo.has(params.token)){
							p = p.catch((e:LinkAuthException) => {
									let redirect = getLoginRedirect(defaultErrorMessage);
									if(e.type === LinkAuthError.INVALID_PASSWORD) {
										redirect = getAuthLinkRedirect(params);
									} 
									else if (e.type === LinkAuthError.LINK_EXPIRED){
										redirect = getLoginRedirect(e.userMessage);
									}
									else if (e.type === LinkAuthError.LINK_NOT_FOUND){
										redirect = getLoginRedirect(e.userMessage);
									} 
									return redirect;
								});
						}
						else {
							p = p.catch((e:LinkAuthException) => {
									let redirect = getLoginRedirect(defaultErrorMessage);
									if(e.type === LinkAuthError.INVALID_ACCESS_CODE || e.type === LinkAuthError.INVALID_PASSWORD) {
										params.invalidPassword = true;
										redirect = getAuthLinkRedirect(params);
									} 
									else if (e.type === LinkAuthError.LINK_EXPIRED){
										redirect = getLoginRedirect(e.userMessage);
									}
									else if (e.type === LinkAuthError.LINK_NOT_FOUND){
										redirect = getLoginRedirect(e.userMessage);
									}
									return redirect;
								});
						}
					}
					return p;
				}
			}

			function generateEmailReferralState(parentStateName:string) {
				return {
					data: {
						isEmailReferral: true
					},
					name: `${parentStateName}.fromEmail`,
					parent: parentStateName,
					url: '/email'
				}
			}
	}])
	.directive('sbaMyFiles', MyFilesDirective);



const template = require('./myFiles.template');
export function MyFilesDirective() {
	return {
		restrict: 'E',
		controller: MyFilesController,
		controllerAs: 'myFilesCtrl',
		template,
		bindToController: true,
		scope: {},
		link: function (scope, element, attrs) {
		}
	};
}

function MyFilesController() {}



// WEBPACK FOOTER //
// ./src/sharebase-app/components/_myFiles/myFiles.ts